import t from 'babel-plugin-yate/macro';

export const PENSIONARY_CODE = 16465;
export const PFA_CODE = 16464;
export const ANAF_CODE = 16521;
export const MAI_MAPN_CODE = 16463;

export const ALL_EMPLOYMENT_STATUSES = {
  [PENSIONARY_CODE]: t`Pensionary`,
  [PFA_CODE]: t`PFA`,
  [ANAF_CODE]: t`Employee with ANAF`,
  [MAI_MAPN_CODE]: t`Employee without ANAF`,
};
